import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app.routes';
import { ApiService } from './api.service';
import { authInterceptor } from './auth.interceptor';
import { AuthService } from './auth.service';
import { CatalogRealtimeService } from './catalog-realtime.service';
import { PresenceService } from './presence.service';
import { UserAvatarService } from './user-avatar.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimations(),
    provideIonicAngular({
      mode: 'md'
    }),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes, withComponentInputBinding()),
    provideAppInitializer(async () => {
      const auth = inject(AuthService);
      const catalogRealtime = inject(CatalogRealtimeService);
      const presence = inject(PresenceService);
      const api = inject(ApiService);
      const avatars = inject(UserAvatarService);
      await auth.initialize();
      void catalogRealtime.start();
      presence.start();
      if (auth.isAuthenticated()) {
        void api
          .getMyProfile()
          .then((profile) => {
            avatars.setCustomAvatarUrl(profile.avatarUrl);
            if (typeof profile.membershipLevel === 'number') {
              auth.setMembershipLevel(profile.membershipLevel);
            }
            if (typeof profile.maxPersonalCollections === 'number') {
              auth.setMaxPersonalCollections(profile.maxPersonalCollections);
            }
          })
          .catch(() => avatars.setCustomAvatarUrl(null));
      }
    })
  ]
};
